/* @flow */
import idx from 'idx';
import GroupMembership from 'entities/GroupMembership';
import Subscriber from 'entities/Subscriber';
import type { UserActionsMenuButtonUser } from 'user/components/UserActionsMenuButton';

export default function mapGraphQLMemberToUserActionsMenuButtonUser(
  subscriber: Subscriber,
  groupMembership: GroupMembership
): UserActionsMenuButtonUser {
  return {
    id: subscriber.id,
    name: subscriber.getName(),
    first_name: subscriber.getFirstName(),
    last_name: subscriber.getLastName(),
    blocked: groupMembership.isBlocked(),

    is_owner: groupMembership.isOwner(),
    can_become_owner: groupMembership.getCanBecomeOwner(),
    can_admin: groupMembership.hasPermission('can_admin'),
    can_remove_from_group: groupMembership.hasPermission('can_remove_from_group'),
    can_remove_from_org: groupMembership.hasPermission('can_remove_from_org'),

    can_have_role_changed:
      idx(groupMembership.getOrgAffiliationView(), _ => _.can_have_role_changed) || false,
    roles: idx(groupMembership.getOrgAffiliationView(), _ => _.roles) || [],
    potential_roles: idx(groupMembership.getOrgAffiliationView(), _ => _.potential_roles) || [],

    can_get_message_history: groupMembership.hasPermission('can_get_message_history'),
    can_request_message_history: groupMembership.hasPermission('can_request_message_history'),
  };
}
